var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-side-modal"},[_c('div',{staticClass:"background-opacity"}),_c('div',{staticClass:"loading-gif-container"},[_c('img',{staticClass:"loading-gif",attrs:{"src":_vm.cx_loading_gif,"loading":"lazy"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }